import React from 'react';
import { useFormikContext } from 'formik';
import { Row, Col } from 'reactstrap';
import { Field } from '@cordata/buffet';

const countConditionOptions = [
  {
    label: 'Is not null',
    value: 'isNotNull',
  },
  {
    label: 'Is true',
    value: 'isTrue',
  },
  {
    label: 'Equals value',
    value: 'equals',
  },
];

const CountColumnForm = ({
  lagTableIndex,
  countIndex,
  columnOptions,
}) => {
  const { values } = useFormikContext();

  const countConfig = values.lagTables?.[lagTableIndex]?.additionalCountColumns?.[countIndex];

  return (
    <>
      <Row form>
        <Col sm>
          <Field
            name={`lagTables.${lagTableIndex}.additionalCountColumns.${countIndex}.label`}
            label="Label"
            text="Display name for this count column (e.g., 'Intakes Completed')"
            required
          />
        </Col>

        <Col sm>
          <Field
            name={`lagTables.${lagTableIndex}.additionalCountColumns.${countIndex}.countWhenColumn`}
            label="Count When Column"
            text="The column to check for counting"
            type="select"
            options={columnOptions}
            required
          />
        </Col>

        <Col sm>
          <Field
            name={`lagTables.${lagTableIndex}.additionalCountColumns.${countIndex}.countCondition`}
            label="Count Condition"
            text="When to count a row"
            type="select"
            options={countConditionOptions}
            required
          />
        </Col>

        {countConfig?.countCondition?.value === 'equals' && (
          <Col sm>
            <Field
              name={`lagTables.${lagTableIndex}.additionalCountColumns.${countIndex}.countValue`}
              label="Value to Match"
              text="Count rows where the column equals this value"
              required
            />
          </Col>
        )}
      </Row>
    </>
  );
};

export default CountColumnForm;
